import _ from 'lodash';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';
import { ModeCollectionFactoryService } from '../model-collection.factory';
import { ModeModelBase, ModeModelInjectables } from '../model';
import { GroupMembershipModel, GroupMembershipModelAccessor } from './group_membership';
import { Injectable } from '@angular/core';

const buildCreator = (group) => {
  return group
    .creator()
    .then((creator) => {
      group.savedCreator = creator;
      return group;
    })
    .catch((e) => {
      return group;
    });
};
export class GroupModel extends ModeModelBase {
  override _name = 'group';
  webLink: any;
  isEveryone: boolean;
  membershipById: any;

  override idAttribute = 'token';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
  override hasMany = [
    { name: 'reports', idAttribute: 'token' },
    { name: 'groupMemberships' },
    { name: 'groupMemberships', as: 'membershipById' },
    { name: 'groupMemberships', as: 'membershipsPreview' },
  ];
  override hasOne = [{ name: 'account', as: 'creator', idAttribute: 'username' }];
  override attributes = [
    { name: 'token', default: null },
    { name: 'name', default: '' },
    { name: 'description', default: '' },
    { name: 'member_count', default: 0 },
    { name: 'group_type', default: 'custom' },
  ];

  constructor(injectables: ModeModelInjectables, private modeCollectionFactoryService: ModeCollectionFactoryService) {
    super(injectables);
  }

  override initialize(resource) {
    if (resource) {
      this.webLink = resource.hasLink('web') ? resource.links('web').href : '#';
    }

    if (resource && resource.group_type === 'everyone') {
      this.isEveryone = true;
    } else {
      this.isEveryone = false;
    }
  }
  findMembership(token, GroupMembershipModel) {
    return this.membershipById({ id: token, refresh: true })
      .then((collections) => this.modeCollectionFactoryService.elements(collections))
      .then((groupMemberships) => {
        return groupMemberships[0];
      });
  }
}

@Injectable({ providedIn: 'root' })
export class GroupModelAccessor extends ModelAccessorBase<GroupModel> {
  override name = 'group';
  override idAttribute = 'token';
  override parentModel = 'account';
  override parentIdAttribute = 'username';
  override createAttributes = ['account'];

  override getIdFromLink = (link) => {
    return link.split('/groups/')[1].split('?')[0];
  };

  constructor(
    injectables: ModelAccessorInjectables,
    private modeCollectionFactoryService: ModeCollectionFactoryService
  ) {
    super(injectables, 'migrated', 'mode.group');
  }

  groupSort(a, b) {
    if (a.group_type === 'everyone') return -1;
    if (b.group_type === 'everyone') return 1;
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    return 0;
  }

  buildGroupsWithCreator(groups) {
    return this.injectables.$q.all(_.map(groups, buildCreator));
  }

  buildGroupsWithFacepiles(groups) {
    return this.injectables.$q.all(_.map(groups, (group) => this.buildFacepiles(group)));
  }

  createModel(resource, opts?) {
    const model = new GroupModel(this.injectables.modelInjectables, this.modeCollectionFactoryService);
    model.$initialize(resource, opts);
    return model;
  }

  buildFacepiles(group) {
    const GroupMembershipModel = this.injectables.modelNameService.get<
      GroupMembershipModel,
      GroupMembershipModelAccessor
    >('groupMembership');
    return group
      .membershipsPreview()
      .then((collection) => this.modeCollectionFactoryService.elements(collection))
      .then((memberships) => {
        return GroupMembershipModel.buildMembershipsWithAccount(memberships);
      })
      .then((memberships) => {
        group.facepileMembers = memberships;
        return group;
      })
      .catch((e) => {
        return group;
      });
  }
}
